/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';

/* -------------------------------------------------------------------------- */
/*                                   Type                                     */
/* -------------------------------------------------------------------------- */
type TApiResponse = {
	entity: string;
	createdBy: string;
	filename: string;
	mimetype: string;
	extension: string;
	size_b: number;
	bucket: string;
	key: string;
	type: 'PICTURE' | 'VIDEO' | 'DOCUMENT'; // a
	link: string;
	acl: string;
	organization: string;
	createdAt: string;
	updatedAt: string;
	id: string;
};

/* -------------------------------------------------------------------------- */
/*                                    Api                                     */
/* -------------------------------------------------------------------------- */
export const getMedia = (
	id: string
): Promise<{
	media: TApiResponse;
}> => {
	return apiClient.get(`/public/media/${id} `);
};

export const useGetMedia = (mediaId: string) => {
	const { data, isLoading } = useQuery({
		queryKey: ['get-media', mediaId],
		queryFn: () => getMedia(mediaId),
	});

	return { data, isLoading };
};
